import React from 'react'


export default class extends React.Component {

  render() {
    document.title = "Ghostin Google Reviews - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";

    var headTag = document.getElementsByTagName('head')[0];
    var charsetTag = document.createElement('meta');
    charsetTag.setAttribute("http-equiv", "refresh");
    charsetTag.setAttribute("content", "0; URL='https://g.page/r/CRtJRuN5YyquEBM/review'");
    headTag.appendChild(charsetTag);

    return (
      <div style={{margin:"3em"}}>Je wordt doorgestuurd naar <a href="https://g.page/r/CRtJRuN5YyquEBM/review">g.page/r/CRtJRuN5YyquEBM/review</a> (Google Reviews)</div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/redir_gmb.js